import { createApp } from './';

const rootId = 'root';

async function prepare() {
  if (import.meta.env.DEV && process.env.DEV_MODE !== 'staging') {
    const { worker } = await import('./test/browser');
    return worker.start({ onUnhandledRequest: 'bypass' });
  }
}
prepare()
  .then(() => createApp({ rootId }))
  .catch(error => {
    console.error('Oops, this should never happen.', error);
  });
